import Vue from "vue";
import VueRouter from "vue-router";

import index from "../views/index.vue";

import notFoundPage from "../views/notFoundPage.vue";

// 데스크탑
// ABOUT
import greetings from "../views/ABOUT/greetings.vue";
import brandIntroduction from "../views/ABOUT/brand-introduction.vue";
import visualIdentity from "../views/ABOUT/visual-identity.vue";
import customerPromise from "../views/ABOUT/customer-promise.vue";
import directions from "../views/ABOUT/directions.vue";

// ABOUT - 기존 페이지 (참고용)
import oldGreetings from "../views/ABOUT/1_greetings.vue";
import information from "../views/ABOUT/2_information.vue";
import identity from "../views/ABOUT/3_identity.vue";
import contribution from "../views/ABOUT/4_contribution.vue";
import contributionPostList from "../views/ABOUT/4_1_contributionPostList.vue";
import contributionPostDetail from "../views/ABOUT/4_2_contributionPostDetail.vue";
import location from "../views/ABOUT/5_location.vue";

// HEARING_AID
import hearingAidNecessity from "../views/HEARING_AID/necessity.vue";
import hearingAidTypes from "../views/HEARING_AID/types.vue";
import hearingAidBrands from "../views/HEARING_AID/brands.vue";
import hearingTest from "../views/HEARING_AID/hearing-test.vue";
import freeTrial from "../views/HEARING_AID/free-trial.vue";

// PRICE
import priceHearingAid from "../views/PRICE/hearing-aid.vue";
import asCost from "../views/PRICE/as-cost.vue";
import subsidy from "../views/PRICE/subsidy.vue";
import insurance from "../views/PRICE/insurance.vue";

// REVIEWS
import reviewHearingTest from "../views/REVIEWS/hearing-test.vue";
import reviewHearingTestDetail from "../views/REVIEWS/hearingTestDetail.vue";
import reviewFreeTrial from "../views/REVIEWS/free-trial.vue";
import reviewFreeTrialDetail from "../views/REVIEWS/freeTrialDetail.vue";
import reviewRealUsage from "../views/REVIEWS/real-usage.vue";
import reviewRealUsageDetail from "../views/REVIEWS/realUsageDetail.vue";

// INFORMATION
import infoHealth from "../views/INFORMATION/health.vue";
import infoHealthDetail from "../views/INFORMATION/healthDetail.vue";
import infoHearingAid from "../views/INFORMATION/hearing-aid.vue";
import infoHearingAidDetail from "../views/INFORMATION/hearingAidDetail.vue";
import infoVideos from "../views/INFORMATION/videos.vue";

// CUSTOMER
import customerNotice from "../views/CUSTOMER/notice.vue";
import customerNoticeDetail from "../views/CUSTOMER/noticeDetail.vue";
import customerRegistration from "../views/CUSTOMER/registration.vue";
import customerConsultation from "../views/CUSTOMER/consultation.vue";
import homeshoppingConsultation from "../views/CUSTOMER/homeshoppingConsultation.vue";

import storeLocator from "../views/CUSTOMER/store-locator.vue";

// PRODUCTS
import glasses from "../views/PRODUCTS/1_glasses.vue";
import glassLens from "../views/PRODUCTS/2_glassLens.vue";
import contactLens from "../views/PRODUCTS/3_contactLens.vue";
import hearingAid from "../views/PRODUCTS/4_hearingAid.vue";

// PARTNERSHIP
import franchise from "../views/PARTNERSHIP/1_franchise.vue";
import howto from "../views/PARTNERSHIP/2_howto.vue";
import inquiryFranchise from "../views/PARTNERSHIP/3_inquiryFranchise.vue";
import inquiryPartnership from "../views/PARTNERSHIP/4_inquiryPartnership.vue";

// EDUCATION
import researchCenter from "../views/EDUCATION/1_researchCenter.vue";
import officer from "../views/EDUCATION/2_officer.vue";
import recruit from "../views/EDUCATION/3_recruit.vue";
import recruitDetail from "../views/EDUCATION/3_2_recruitDetail.vue";

// WHATSNEW
import cf from "../views/WHATSNEW/1_cf.vue";
import davichNews from "../views/WHATSNEW/2_davichNews.vue";
import davichNewsDetail from "../views/WHATSNEW/2_2_davichNewsDetail.vue";
import magazine from "../views/WHATSNEW/3_magazine.vue";
import magazineDetail from "../views/WHATSNEW/3_2_magazineDetail.vue";
import event from "../views/WHATSNEW/4_event.vue";

// SUPPORT
import ask from "../views/SUPPORT/1_ask.vue";
import faq from "../views/SUPPORT/2_faq.vue";
import giftCard from "../views/SUPPORT/3_giftCard.vue";
import findStore from "../views/SUPPORT/4_findStore.vue";

import privacyPolicy from "../views/PRIVACY/1_privacyPolicy.vue";
import emailProtect from "../views/PRIVACY/2_emailProtect.vue";
import cctvPolicy from "../views/PRIVACY/3_cctvPolicy.vue";

import VueGtag from "vue-gtag";

Vue.use(VueRouter);

// 단일(PC용) 라우터만 사용
const router = new VueRouter({
  mode: "history",
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return {
        x: 0,
        y: 0,
      };
    }
  },
  routes: [
    {
      path: "/",
      name: "index",
      component: index,
      meta: {
        title: "다비치히어링 보청기 홈페이지",
      },
    },

    // PRIVACY
    {
      path: "/privacy/privacyPolicy",
      name: "privacyPolicy",
      component: privacyPolicy,
      meta: {
        title: "개인정보처리방침 - DAVICH HEARING",
      },
    },
    {
      path: "/privacy/emailProtect",
      name: "emailProtect",
      component: emailProtect,
      meta: {
        title: "이메일주소 무단수집거부 - DAVICH HEARING",
      },
    },
    {
      path: "/privacy/cctvPolicy",
      name: "cctvPolicy",
      component: cctvPolicy,
      meta: {
        title: "고정형 영상정보처리기기 운영·관리방침 - DAVICH HEARING",
      },
    },

    // ABOUT
    {
      path: "/about",
      name: "about",
      component: greetings,
      meta: {
        title: "다비치 히어링 - DAVICH HEARING",
      },
    },
    {
      path: "/about/greetings",
      name: "greetings",
      component: greetings,
      meta: {
        title: "대표 인사말 - DAVICH HEARING",
      },
    },
    {
      path: "/about/brand-introduction",
      name: "brandIntroduction",
      component: brandIntroduction,
      meta: {
        title: "브랜드 소개 - DAVICH HEARING",
      },
    },
    {
      path: "/about/visual-identity",
      name: "visualIdentity",
      component: visualIdentity,
      meta: {
        title: "비주얼 아이덴티티 - DAVICH HEARING",
      },
    },
    {
      path: "/about/customer-promise",
      name: "customerPromise",
      component: customerPromise,
      meta: {
        title: "고객과의 약속 - DAVICH HEARING",
      },
    },
    {
      path: "/about/directions",
      name: "directions",
      component: directions,
      meta: {
        title: "오시는 길 - DAVICH HEARING",
      },
    },
    // ABOUT - 기존 페이지 (참고용)
    {
      path: "/about/information",
      name: "information",
      component: information,
    },
    {
      path: "/about/identity",
      name: "identity",
      component: identity,
    },
    {
      path: "/about/contribution",
      name: "contribution",
      component: contribution,
    },
    {
      path: "/about/contributionPostList",
      name: "contributionPostList",
      component: contributionPostList,
      props: true,
    },
    {
      path: "/about/contributionPostDetail/:boardid",
      name: "contributionPostDetail",
      component: contributionPostDetail,
      props: true,
    },
    {
      path: "/about/location",
      name: "location",
      component: location,
    },

    // HEARING_AID
    {
      path: "/hearing-aid/necessity",
      name: "hearingAidNecessity",
      component: hearingAidNecessity,
      meta: {
        title: "보청기 필요성 - DAVICH HEARING",
      },
    },
    {
      path: "/hearing-aid/types",
      name: "hearingAidTypes",
      component: hearingAidTypes,
      meta: {
        title: "보청기 종류 - DAVICH HEARING",
      },
    },
    {
      path: "/hearing-aid/brands",
      name: "hearingAidBrands",
      component: hearingAidBrands,
      meta: {
        title: "보청기 브랜드 - DAVICH HEARING",
      },
    },
    {
      path: "/hearing-aid/hearing-test",
      name: "hearingTest",
      component: hearingTest,
      meta: {
        title: "청력 검사 - DAVICH HEARING",
      },
    },
    {
      path: "/hearing-aid/free-trial",
      name: "freeTrial",
      component: freeTrial,
      meta: {
        title: "무료 체험 - DAVICH HEARING",
      },
    },

    // PRICE
    {
      path: "/price/hearing-aid",
      name: "priceHearingAid",
      component: priceHearingAid,
      meta: {
        title: "보청기 가격 - DAVICH HEARING",
      },
    },
    {
      path: "/price/as-cost",
      name: "asCost",
      component: asCost,
      meta: {
        title: "A/S 비용 - DAVICH HEARING",
      },
    },
    {
      path: "/price/subsidy",
      name: "subsidy",
      component: subsidy,
      meta: {
        title: "보청기 지원금 - DAVICH HEARING",
      },
    },
    {
      path: "/price/insurance",
      name: "insurance",
      component: insurance,
      meta: {
        title: "분실파손 보험 - DAVICH HEARING",
      },
    },

    // REVIEWS
    {
      path: "/reviews/hearing-test",
      name: "reviewHearingTest",
      component: reviewHearingTest,
      meta: {
        title: "청력검사 후기 - DAVICH HEARING",
      },
    },
    {
      path: "/reviews/hearing-test/:id",
      name: "reviewHearingTestDetail",
      component: reviewHearingTestDetail,
      props: true,
      meta: {
        title: "청력검사 후기 상세 - DAVICH HEARING",
      },
    },
    {
      path: "/reviews/free-trial",
      name: "reviewFreeTrial",
      component: reviewFreeTrial,
      meta: {
        title: "무료체험 후기 - DAVICH HEARING",
      },
    },
    {
      path: "/reviews/free-trial/:id",
      name: "reviewFreeTrialDetail",
      component: reviewFreeTrialDetail,
      props: true,
      meta: {
        title: "무료체험 후기 상세 - DAVICH HEARING",
      },
    },
    {
      path: "/reviews/real-usage",
      name: "reviewRealUsage",
      component: reviewRealUsage,
      meta: {
        title: "실사용 후기 - DAVICH HEARING",
      },
    },
    {
      path: "/reviews/real-usage/:id",
      name: "reviewRealUsageDetail",
      component: reviewRealUsageDetail,
      props: true,
      meta: {
        title: "실사용 후기 상세 - DAVICH HEARING",
      },
    },

    // INFORMATION
    {
      path: "/information/health",
      name: "infoHealth",
      component: infoHealth,
      meta: {
        title: "건강 정보 - DAVICH HEARING",
      },
    },
    {
      path: "/information/health/:id",
      name: "infoHealthDetail",
      component: infoHealthDetail,
      props: true,
      meta: {
        title: "건강 정보 상세 - DAVICH HEARING",
      },
    },
    {
      path: "/information/hearing-aid",
      name: "infoHearingAid",
      component: infoHearingAid,
      meta: {
        title: "보청기 정보 - DAVICH HEARING",
      },
    },
    {
      path: "/information/hearing-aid/:id",
      name: "infoHearingAidDetail",
      component: infoHearingAidDetail,
      props: true,
      meta: {
        title: "보청기 정보 상세 - DAVICH HEARING",
      },
    },
    {
      path: "/information/videos",
      name: "infoVideos",
      component: infoVideos,
      meta: {
        title: "안내 영상 - DAVICH HEARING",
      },
    },

    // CUSTOMER
    {
      path: "/customer/notice",
      name: "customerNotice",
      component: customerNotice,
      meta: {
        title: "공지사항 - DAVICH HEARING",
      },
    },
    {
      path: "/customer/notice/:id",
      name: "customerNoticeDetail",
      component: customerNoticeDetail,
      props: true,
      meta: {
        title: "공지사항 상세 - DAVICH HEARING",
      },
    },
    {
      path: "/customer/registration",
      name: "customerRegistration",
      component: customerRegistration,
      meta: {
        // title: "정품 등록 - DAVICH HEARING",
        title: "AS 안심 서비스 조회 - DAVICH HEARING",
      },
    },
    {
      path: "/customer/consultation",
      name: "customerConsultation",
      component: customerConsultation,
      meta: {
        title: "상담 예약 - DAVICH HEARING",
      },
    },
    {
      path: "/customer/homeshopping-consultation",
      name: "homeshoppingConsultation",
      component: homeshoppingConsultation,
      meta: {
        // title: "홈쇼핑 상담 예약 - DAVICH HEARING",
        title: "홈쇼핑 상담 예약 - DAVICH HEARING",
      },
    },
    {
      path: "/customer/store-locator",
      name: "storeLocator",
      component: storeLocator,
      meta: {
        title: "매장 찾기 - DAVICH HEARING",
      },
    },

    // PRODUCTS
    {
      path: "/products/glasses",
      name: "glasses",
      component: glasses,
    },
    {
      path: "/products/glassLens",
      name: "glassLens",
      component: glassLens,
    },
    {
      path: "/products/contactLens",
      name: "contactLens",
      component: contactLens,
    },
    {
      path: "/products/hearingAid",
      name: "hearingAid",
      component: hearingAid,
    },

    // PARTNERSHIP
    {
      path: "/partnership/franchise",
      name: "franchise",
      component: franchise,
    },
    {
      path: "/partnership/howto",
      name: "howto",
      component: howto,
    },
    {
      path: "/partnership/inquiryFranchise",
      name: "inquiryFranchise",
      component: inquiryFranchise,
    },
    {
      path: "/partnership/inquiryPartnership",
      name: "inquiryPartnership",
      component: inquiryPartnership,
    },

    // EDUCATION
    {
      path: "/education/researchCenter",
      name: "researchCenter",
      component: researchCenter,
    },
    {
      path: "/education/officer",
      name: "officer",
      component: officer,
    },
    {
      path: "/education/recruit",
      name: "recruit",
      component: recruit,
      props: true,
    },
    {
      path: "/education/recruitDetail/:boardid",
      name: "recruitDetail",
      component: recruitDetail,
      props: true,
    },

    // WHATSNEW
    {
      path: "/whatsnew/cf",
      name: "cf",
      component: cf,
    },
    {
      path: "/whatsnew/davichNews",
      name: "davichNews",
      component: davichNews,
    },
    {
      path: "/whatsnew/davichNewsDetail/:boardid",
      name: "davichNewsDetail",
      component: davichNewsDetail,
      props: true,
    },
    {
      path: "/whatsnew/magazine",
      name: "magazine",
      component: magazine,
    },
    {
      path: "/whatsnew/magazineDetail/:boardid",
      name: "magazineDetail",
      component: magazineDetail,
      props: true,
    },
    {
      path: "/whatsnew/event",
      name: "event",
      component: event,
    },

    // SUPPORT
    {
      path: "/support/ask",
      name: "ask",
      component: ask,
    },
    {
      path: "/support/faq",
      name: "faq",
      component: faq,
    },
    {
      path: "/support/giftCard",
      name: "giftCard",
      component: giftCard,
      props: true,
    },
    {
      path: "/support/findStore",
      name: "findStore",
      component: findStore,
    },

    // (옵션) 모바일용 URL 패턴이지만 PC 컴포넌트로 처리하는 라우트
    // 필요 없으면 이 블록 전체를 삭제해도 됨.
    //PRIVACY
    {
      path: "/privacy/m_privacyPolicy",
      name: "privacyPolicy",
      component: privacyPolicy,
      meta: {
        title: "개인정보처리방침 - DAVICH HEARING",
      },
    },
    {
      path: "/privacy/m_emailProtect",
      name: "emailProtect",
      component: emailProtect,
      meta: {
        title: "이메일주소 무단수집거부 - DAVICH HEARING",
      },
    },
    {
      path: "/privacy/m_cctvPolicy",
      name: "cctvPolicy",
      component: cctvPolicy,
      meta: {
        title: "고정형 영상정보처리기기 운영·관리방침 - DAVICH HEARING",
      },
    },

    // ABOUT
    {
      path: "/about/m_greetings",
      name: "m_greetings",
      component: greetings,
    },
    {
      path: "/about/m_brand-introduction",
      name: "m_brandIntroduction",
      component: brandIntroduction,
    },
    {
      path: "/about/m_visual-identity",
      name: "m_visualIdentity",
      component: visualIdentity,
    },
    {
      path: "/about/m_customer-promise",
      name: "m_customerPromise",
      component: customerPromise,
    },
    {
      path: "/about/m_directions",
      name: "m_directions",
      component: directions,
    },
    // ABOUT - 기존 페이지 (참고용, 모바일)
    {
      path: "/about/m_information",
      name: "m_information",
      component: information,
    },
    {
      path: "/about/m_identity",
      name: "m_identity",
      component: identity,
    },
    {
      path: "/about/m_contribution",
      name: "m_contribution",
      component: contribution,
    },
    {
      path: "/about/m_contributionPostList",
      name: "m_contributionPostList",
      component: contributionPostList,
      props: true,
    },
    {
      path: "/about/m_contributionPostDetail/:boardid",
      name: "m_contributionPostDetail",
      component: contributionPostDetail,
      props: true,
    },
    {
      path: "/about/m_location",
      name: "m_location",
      component: location,
    },

    // PRODUCTS
    {
      path: "/products/m_glasses",
      name: "glasses",
      component: glasses,
    },
    {
      path: "/products/m_glassLens",
      name: "glassLens",
      component: glassLens,
    },
    {
      path: "/products/m_contactLens",
      name: "contactLens",
      component: contactLens,
    },
    {
      path: "/products/m_hearingAid",
      name: "hearingAid",
      component: hearingAid,
    },

    // PARTNERSHIP
    {
      path: "/partnership/m_franchise",
      name: "franchise",
      component: franchise,
    },
    {
      path: "/partnership/m_howto",
      name: "howto",
      component: howto,
    },
    {
      path: "/partnership/m_inquiryFranchise",
      name: "inquiryFranchise",
      component: inquiryFranchise,
    },
    {
      path: "/partnership/m_inquiryPartnership",
      name: "inquiryPartnership",
      component: inquiryPartnership,
    },

    // EDUCATION
    {
      path: "/education/m_researchCenter",
      name: "researchCenter",
      component: researchCenter,
    },
    {
      path: "/education/m_officer",
      name: "officer",
      component: officer,
    },
    {
      path: "/education/m_recruit",
      name: "recruit",
      component: recruit,
      props: true,
    },
    {
      path: "/education/m_recruitDetail/:boardid",
      name: "recruitDetail",
      component: recruitDetail,
      props: true,
    },

    // WHATSNEW
    {
      path: "/whatsnew/m_cf",
      name: "cf",
      component: cf,
    },
    {
      path: "/whatsnew/m_davichNews",
      name: "davichNews",
      component: davichNews,
    },
    {
      path: "/whatsnew/m_davichNewsDetail/:boardid",
      name: "davichNewsDetail",
      component: davichNewsDetail,
      props: true,
    },
    {
      path: "/whatsnew/m_magazine",
      name: "magazine",
      component: magazine,
    },
    {
      path: "/whatsnew/m_magazineDetail/:boardid",
      name: "magazineDetail",
      component: magazineDetail,
      props: true,
    },
    {
      path: "/whatsnew/m_event",
      name: "event",
      component: event,
    },

    // SUPPORT
    {
      path: "/support/m_ask",
      name: "ask",
      component: ask,
    },
    {
      path: "/support/m_faq",
      name: "faq",
      component: faq,
    },
    {
      path: "/support/m_giftCard",
      name: "giftCard",
      component: giftCard,
      props: true,
    },
    {
      path: "/support/m_findStore",
      name: "findStore",
      component: findStore,
    },

    // PC notfoundpage
    {
      path: "/notFound",
      name: "notFoundPage",
      component: notFoundPage,
    },
    {
      path: "/:pathMatch(.*)*",
      redirect: "/notFound",
    },
  ],
});

// 웹 타이틀
router.afterEach((to, from) => {
  const title = to.meta.title === undefined ? "DAVICH HEARING" : to.meta.title;
  Vue.nextTick(() => {
    document.title = title;
  });
});

// 구글 애널리틱스 적용 (단일 라우터 기준)
Vue.use(
    VueGtag,
    {
      config: { id: "G-JR5148JL5F" },
    },
    router
);

export default router;
